import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_viewer/viewer-device";

export const Route = createFileRoute("/_authenticated/viewer-device")({
  validateSearch: (search: Record<string, unknown>) => ({
    conteudo: typeof search.conteudo === "string" ? search.conteudo : "",
  }),
  head: () => ({
    meta: [
      { title: "Informações do dispositivo — Milky Moo Palmares" },
      { name: "description", content: "Visualização setorizada das informações do dispositivo." },
    ],
  }),
  component: PaginaRota,
});
